import React from 'react';

export const ContactMail = () => {
    return (
        <a href="mailto:support@iglnetwork.com" target="_blank">
            <div className="mail-raw">
            </div>
        </a>
    )
}